import type { RouteRecordRaw } from 'vue-router'

export const accountAuthRoutes = [
  {
    path: 'login',
    name: 'login',
    component: () => import('@/modules/account/views/Login.vue'),
    meta: { requiresAuth: false },
  },
] as RouteRecordRaw[]

export const accountProtectedRoutes = [
  {
    path: '/account/profile',
    name: 'account.profile',
    component: () => import('@/modules/account/views/Profile.vue'),
    meta: { requiresAuth: true },
  },
] as RouteRecordRaw[]
